import api from '../../../utils/api';

export const getEmailTemplates = async () => {
  return (await api.get(`/Utilities/Utilities/GetAllEmailTemplate`))?.data as APIResponse<EmailTemplate[]>;
};

export const getEmailTemplateById = async (id: number) => {
  return (await api.get(`/Utilities/Utilities/GetEmailTemplateById?Id=${id}`))?.data as APIResponse<EmailTemplate>;
};

export const createUpdateEmailTemplate = async (payload: FormData) => {
  return (await api.post(`/Utilities/Utilities/CreateUpdateEmailTemplate`, payload))
    ?.data as APIResponse<EmailTemplate>;
};
